<template>
  <div>
    <b-form-group class="mt-4" label="Nome" label-for="sectorName">
      <b-form-input
        type="text"
        id="input-nomeAcesso"
        placeholder="Informe o nome de acesso"
        v-model="model.displayName"
      />
      <span class="text-danger" v-if="modelstate['DisplayName']">
        {{ "* " + modelstate["DisplayName"][0] }}
      </span>
    </b-form-group>

    <!-- Gestores -->
    <b-row class="mt-4">
      <b-col class="mt-2" cols="3">
        <h3 for="managers">{{ $t("sector.managers") }}</h3>
      </b-col>
    </b-row>

    <b-table
      ref="tableManagers"
      class="table-nowrap mt-2"
      :busy.sync="isBusy"
      :items="model.managers"
      :fields="fields"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
      :emptyText="$t('sector.noRecordManager')"
      show-empty
      striped
      hover
    >
      <template #cell(actions)="data">
        <!-- {{ data }} -->
        <b-button
          variant="danger"
          :title="$t('checklist.form.fieldDelete')"
          v-b-tooltip.hover
          size="sm"
          @click="removeManagers(data.item)"
        >
          x
        </b-button>
      </template>
    </b-table>

    <b-row class="d-flex mt-2">
      <b-button
        style="margin-left: 15px"
        :title="$t('geral.add')"
        v-b-tooltip.hover
        size="sm"
        @click="openManagerModal()"
      >
        {{ $t("sector.addManager") }}
      </b-button>
    </b-row>

    <b-row class="mt-4">
      <b-col class="mt-2" cols="3">
        <h3 for="employees">{{ $t("sector.employees") }}</h3>
      </b-col>
    </b-row>

    <!-- Funcionarios -->
    <b-table
      ref="tableEmployees"
      class="table-nowrap mt-2"
      :busy.sync="isBusy"
      :items="model.employees"
      :fields="fields"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
      :emptyText="$t('sector.noRecordEmployee')"
      show-empty
      striped
      hover
    >
      <template #cell(actions)="data">
        <!-- {{ data }} -->
        <b-button
          variant="danger"
          size="sm"
          :title="$t('checklist.form.fieldDelete')"
          v-b-tooltip.hover
          @click="removeEmployees(data.item)"
        >
          x
        </b-button>
      </template>
    </b-table>

    <b-row class="d-flex mt-2">
      <b-col>
        <b-button
          :title="$t('geral.add')"
          v-b-tooltip.hover
          size="sm"
          @click="openEmployeesModal()"
        >
          {{ $t("sector.addEmployee") }}
        </b-button>
      </b-col>
    </b-row>

    <select-user-modal
      ref="selectManagerModal"
      :selected.sync="model.managers"
    />
    <select-user-modal
      ref="selectEmployeesModal"
      :selected.sync="model.employees"
    />
    <!-- <div>{{ model }}</div> -->
  </div>
</template>
<script>
export default {
  name: "SectorCrud",
  props: {
    model: Object,
    modelstate: Object
  },
  components: {
    SelectUserModal: () =>
      import("@/components_rms/System/Sector/SelectUserModal.vue")
  },
  created() {
    this.getAllUsers();
  },
  data() {
    return {
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "presentationName",
          filterKey: "presentationName",
          sortable: false,
          label: "Nome",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "profile",
          filterKey: "profile",
          sortable: false,
          label: "Perfil",
          tdClass: "table-col-dinamic-width"
        }
      ],
      newEmployeer: "",
      // managersActive: [],
      // employeesActive: [],
      tableCurrentPage: 1,
      tablePerPage: 10,
      isBusy: false,
      isLoadingPage: true
    };
  },

  methods: {
    openManagerModal() {
      this.$refs.selectManagerModal.show();
    },
    openEmployeesModal() {
      this.$refs.selectEmployeesModal.show();
    },
    removeManagers(manager) {
      let selectedIndex = this.model.managers.indexOf(manager);
      this.model.managers.splice(selectedIndex, 1);
    },
    removeEmployees(employees) {
      let selectedIndex = this.model.employees.indexOf(employees);
      this.model.employees.splice(selectedIndex, 1);
    },
    autocomplet(value) {
      let allUsers = [];
      this.users.forEach(user => {
        if (user.text.toUpperCase().includes(value.toUpperCase())) {
          allUsers.push(user.text);
        }
      });
      console.log(allUsers);
    }
  }
};
</script>
